import { Dispatch } from "redux";
import { setIsDeleteScheduledQualificationModalOpen } from "../ScheduledQualificationsSlice";
import { toast } from "react-toastify";

interface Props {
    id: string;
    deleteScheduledQualification: (params: { id: string }) => {
        unwrap: () => Promise<unknown>;
    };
    dispatch: Dispatch;
}

export const handleDeleteScheduledQualification = async (
    props: Props,
): Promise<void> => {
    const { id, deleteScheduledQualification, dispatch } = props;

    try {
        await deleteScheduledQualification({ id })
            .unwrap()
            .then(() => {
                dispatch(setIsDeleteScheduledQualificationModalOpen(false));
                toast.success("Ingeplande kwalificatie verwijderd");
            });
    } catch (error) {
        console.error("Error deleting scheduled qualification:", error);
        toast.error("Er is iets misgegaan");
    }
};
